import { Controller } from "@hotwired/stimulus"

// Manages funerary plan items (included services) nested attributes
export default class extends Controller {
  static targets = ["container", "template", "item", "destroy", "select", "quantity", "name", "description"]
  static values = {
    index: { type: Number, default: 0 },
    items: { type: Array, default: [] }
  }

  add(event) {
    event.preventDefault()

    const template = this.templateTarget.innerHTML
    const index = this.indexValue
    this.indexValue = index + 1

    const newContent = template.replace(/NEW_INDEX/g, index)

    const wrapper = document.createElement("div")
    wrapper.innerHTML = newContent.trim()

    this.containerTarget.appendChild(wrapper.firstElementChild)
  }

  remove(event) {
    event.preventDefault()
    const item = event.target.closest("[data-funerary-plan-items-target='item']")

    if (item) {
      // Check if it has a destroy hidden field (existing record)
      const destroyField = item.querySelector("input[name*='_destroy']")

      if (destroyField) {
        destroyField.value = "1"
        item.classList.add("hidden")
      } else {
        item.remove()
      }
    }
  }

  selectItem(event) {
    const select = event.target
    const selectedId = parseInt(select.value)
    const itemRow = select.closest("[data-funerary-plan-items-target='item']")

    if (!itemRow) return

    const quantityField = itemRow.querySelector("[data-funerary-plan-items-target='quantity']")
    const nameField = itemRow.querySelector("[data-funerary-plan-items-target='name']")
    const descriptionField = itemRow.querySelector("[data-funerary-plan-items-target='description']")

    if (selectedId && this.itemsValue.length > 0) {
      // Find the selected funerary item from the data
      const funeraryItem = this.itemsValue.find(item => item.id === selectedId)

      if (funeraryItem) {
        // Auto-fill quantity with default if not already set or if it's 1
        if (quantityField && (!quantityField.value || quantityField.value === "1")) {
          quantityField.value = funeraryItem.default_quantity || 1
        }

        // Clear custom name since we're using a predefined item
        if (nameField) {
          nameField.value = ""
          nameField.placeholder = `Usando: ${funeraryItem.name} (deixe em branco para usar o padrão)`
        }

        // Clear custom description
        if (descriptionField) {
          descriptionField.value = ""
          if (funeraryItem.description) {
            descriptionField.placeholder = `Padrão: ${funeraryItem.description.substring(0, 100)}...`
          } else {
            descriptionField.placeholder = "Descrição personalizada (opcional)"
          }
        }
      }
    } else {
      // Custom item - reset placeholders
      if (nameField) {
        nameField.placeholder = "Nome do item (obrigatório para item personalizado)"
      }
      if (descriptionField) {
        descriptionField.placeholder = "Descrição detalhada do item/serviço..."
      }
    }
  }
}
